import {Injectable} from '@angular/core';
import {Principal} from '../principal.service';
import {UserRole} from '../user-role.model';

export enum RolePermission {
  PLACEMENT_CREATE = 'PLACEMENT_CREATE',
  PLACEMENT_EDIT = 'PLACEMENT_EDIT',
  PLACEMENT_ARCHIVE = 'PLACEMENT_ARCHIVE',
  APP_CSV_IMPORT = 'APP_CSV_IMPORT',
  APP_CREATE = 'APP_CREATE',
  APP_EDIT = 'APP_EDIT',
  APP_ARCHIVE = 'APP_ARCHIVE',
  APP_REQUEST_CREATE = 'APP_REQUEST_CREATE',
  APP_REQUEST_EDIT = 'APP_REQUEST_EDIT',
  APP_REQUEST_DISCONNECT = 'APP_REQUEST_DISCONNECT',
  APP_DP_IDS_CREATE = 'APP_DP_IDS_CREATE',
  TARGETING_CREATE = 'TARGETING_CREATE',
  TARGETING_READ = 'TARGETING_READ',
  TARGETING_EDIT = 'TARGETING_EDIT',
  TARGETING_ARCHIVE = 'TARGETING_ARCHIVE',
  ADSTXT_RECORDS_CREATE = 'ADSTXT_RECORDS_CREATE',
  ADSTXT_RECORDS_EDIT = 'ADSTXT_RECORDS_EDIT',
  ADSTXT_RECORDS_ARCHIVE = 'ADSTXT_RECORDS_ARCHIVE',
  ADSTXT_APPS_CRAWL = 'ADSTXT_APPS_CRAWL',
  ADSTXT_DOMAINS_CRAWL = 'ADSTXT_DOMAINS_CRAWL',
  MARKETPLACE_CREATE = 'MARKETPLACE_CREATE',
  MARKETPLACE_EDIT = 'MARKETPLACE_EDIT',
  PUBLISHER_CREATE = 'PUBLISHER_CREATE',
  PUBLISHER_EDIT = 'PUBLISHER_EDIT',
  PUBLISHER_ADSTXT_CRAWL = 'PUBLISHER_ADSTXT_CRAWL',
  PUBLISHER_A2V_CREATE = 'PUBLISHER_A2V_CREATE',
  PUBLISHER_APPROVALS_CREATE = 'PUBLISHER_APPROVALS_CREATE',
  DOMAIN_CREATE = 'DOMAIN_CREATE',
  DOMAIN_EDIT = 'DOMAIN_EDIT',
  DOMAIN_ARCHIVE = 'DOMAIN_ARCHIVE',
  NETWORK_CREATE = 'NETWORK_CREATE',
  NETWORK_EDIT = 'NETWORK_EDIT',
  NETWORK_ARCHIVE = 'NETWORK_ARCHIVE',
  DP_CREATE = 'DP_CREATE',
  DP_EDIT = 'DP_EDIT',
  DP_ARCHIVE = 'DP_ARCHIVE',
  DP_IMPORT_CSV = 'DP_IMPORT_CSV',
  CONNECTION_CREATE = 'CONNECTION_CREATE',
  CONNECTION_EDIT = 'CONNECTION_EDIT',
  CONNECTION_DUPLICATE = 'CONNECTION_DUPLICATE',
  COMPLIANCE_DOMAIN_CREATE = 'COMPLIANCE_DOMAIN_CREATE',
  COMPLIANCE_DOMAIN_EDIT = 'COMPLIANCE_DOMAIN_EDIT',
  SOURCES_CREATE = 'SOURCES_CREATE',
  SOURCES_EDIT = 'SOURCES_EDIT',
  SOURCES_ARCHIVE = 'SOURCES_ARCHIVE',
  SOURCES_TEMPLATE_CREATE = 'SOURCES_TEMPLATE_CREATE',
  SOURCES_TEMPLATE_EDIT = 'SOURCES_TEMPLATE_EDIT',
  SOURCES_TEMPLATE_ARCHIVE = 'SOURCES_TEMPLATE_ARCHIVE',
  IMAGE_CREATIVES_CREATE = 'IMAGE_CREATIVES_CREATE',
  IMAGE_CREATIVES_EDIT = 'IMAGE_CREATIVES_EDIT',
  IMAGE_CREATIVES_ARCHIVE = 'IMAGE_CREATIVES_ARCHIVE',
  ASSETS_CREATE = 'ASSETS_CREATE',
  ASSETS_EDIT = 'ASSETS_EDIT',
  GLOBAL_BRAND_TEMPLATE = 'GLOBAL_BRAND_TEMPLATE',
  BRAND_CREATE = 'BRAND_CREATE',
  BRAND_EDIT = 'BRAND_EDIT',
  NETWORK_TEMPLATE_CREATE = 'NETWORK_TEMPLATE_CREATE',
  COLLECTION_CREATE = 'COLLECTION_CREATE',
  COLLECTION_EDIT = 'COLLECTION_EDIT',
  VIDEOS_CREATE = 'VIDEOS_CREATE',
  VIDEOS_EDIT = 'VIDEOS_EDIT',
  VIDEOS_METADATA_CREATE = 'VIDEOS_METADATA_CREATE',
  CONTENT_OWNER_CREATE = 'CONTENT_OWNER_CREATE',
  CONTENT_OWNER_EDIT = 'CONTENT_OWNER_EDIT',
  USERS_CREATE = 'USERS_CREATE',
  USERS_EDIT = 'USERS_EDIT',
  RB_SCHEDULE_CREATE = 'RB_SCHEDULE_CREATE',
  CUSTOM_REPORTS_CREATE = 'CUSTOM_REPORTS_CREATE',
  ENDPOINT_GENERATOR_CREATE = 'ENDPOINT_GENERATOR_CREATE',
  OANDO_APPS_CREATE = 'OANDO_APPS_CREATE',
  OANDO_APPS_EDIT = 'OANDO_APPS_EDIT',
  CHANGELOG_EXPORT = 'CHANGELOG_EXPORT',
  CHANGELOG_READ = 'CHANGELOG_READ',
  SUPPLY_MARKETPLACE_CREATE = 'SUPPLY_MARKETPLACE_CREATE',
  SUPPLY_MARKETPLACE_EDIT = 'SUPPLY_MARKETPLACE_EDIT',
  SUPPLY_MARKETPLACE_ARCHIVE = 'SUPPLY_MARKETPLACE_ARCHIVE',
  FORECAST_CREATE = 'FORECAST_CREATE',
  ADVERTISER_CREATE = 'ADVERTISER_CREATE',
  ADVERTISER_EDIT = 'ADVERTISER_EDIT',
  ADVERTISER_ARCHIVE = 'ADVERTISER_ARCHIVE',
  PMP_CREATE = 'PMP_CREATE',
  PMP_EDIT = 'PMP_EDIT',
  PMP_ARCHIVE = 'PMP_ARCHIVE',
  TAXONOMY_GENRES_CREATE = 'TAXONOMY_GENRES_CREATE',
  TAXONOMY_GENRES_EDIT = 'TAXONOMY_GENRES_EDIT',
  TAXONOMY_GENRES_ARCHIVE = 'TAXONOMY_GENRES_ARCHIVE',
  MARKETPLACE_ROUTING_CREATE = 'MARKETPLACE_ROUTING_CREATE',
  MARKETPLACE_ROUTING_EDIT = 'MARKETPLACE_ROUTING_EDIT',
  MARKETPLACE_ROUTING_ARCHIVE = 'MARKETPLACE_ROUTING_ARCHIVE',
  PUBLISHER_KEYWORDS_CREATE = 'PUBLISHER_KEYWORDS_CREATE',
  PUBLISHER_KEYWORDS_EDIT = 'PUBLISHER_KEYWORDS_EDIT',
  PUBLISHER_KEYWORDS_ARCHIVE = 'PUBLISHER_KEYWORDS_ARCHIVE',
  KEYWORDS_CREATE = 'KEYWORDS_CREATE',
  KEYWORDS_EDIT = 'KEYWORDS_EDIT',
  KEYWORDS_ARCHIVE = 'KEYWORDS_ARCHIVE',

  CAMPAIGNS_READ = 'campaigns:read',
  CAMPAIGNS_ORDERS_READ = 'campaigns.orders:read',
  CAMPAIGNS_ORDERS_ORDER_CREATE = 'campaigns.orders.order:create',
  CAMPAIGNS_ORDERS_ORDER_UPDATE = 'campaigns.orders.order:update',
  CAMPAIGNS_ORDERS_ORDER_ARCHIVE = 'campaigns.orders.order:archive',
  CAMPAIGNS_ORDERS_LINEITEM_READ = 'campaigns.orders.lineitem:read',
  CAMPAIGNS_ORDERS_LINEITEM_CREATE = 'campaigns.orders.lineitem:create',
  CAMPAIGNS_ORDERS_LINEITEM_UPDATE = 'campaigns.orders.lineitem:update',
  CAMPAIGNS_ORDERS_LINEITEM_DUPLICATE = 'campaigns.orders.lineitem:duplicate',
  CAMPAIGNS_ORDERS_LINEITEM_ARCHIVE = 'campaigns.orders.lineitem:archive',
  CAMPAIGNS_CREATIVES_READ = 'campaigns.creatives:read',
  CAMPAIGNS_CREATIVES_CREATE = 'campaigns.creatives:create',
  CAMPAIGNS_CREATIVES_UPDATE = 'campaigns.creatives:update',
  CAMPAIGNS_CREATIVES_ARCHIVE = 'campaigns.creatives:archive',
  CAMPAIGNS_CREATIVES_VAST = 'campaigns.creatives:vast',
  CAMPAIGNS_CREATIVES_MOMENTS_JSON = 'campaigns.creatives:moment_json',
  CAMPAIGNS_CREATIVES_SETTINGS = 'campaigns.creatives:settings',
  CAMPAIGNS_CREATIVES_PROCESS = 'campaigns.creatives:process',
}

const RolesWithPermissions = {

  [UserRole.ADMIN]: Object.values(RolePermission), // all
  [UserRole.READ_ONLY_ADMIN]: Object.values(RolePermission).filter((ur: RolePermission) => {
    if (ur.includes('EDIT') || ur.includes('UPDATE')) {
      return ur;
    }
  }), //leave edits so user can open edit windows but cant save anything since all save buttons are locked behind create permissions
  [UserRole.SALES_REPRESENTATIVE]: Object.values(RolePermission).filter((ur: RolePermission) => ![
    RolePermission.PUBLISHER_CREATE,
    RolePermission.PUBLISHER_EDIT,
    RolePermission.PUBLISHER_ADSTXT_CRAWL,
    RolePermission.APP_ARCHIVE,
    RolePermission.ADSTXT_APPS_CRAWL,
    RolePermission.CHANGELOG_EXPORT,
    RolePermission.ENDPOINT_GENERATOR_CREATE,
    RolePermission.APP_EDIT].includes(ur)),
  [UserRole.CAMPAIGN_MANAGER]: Object.values(RolePermission).filter((ur: RolePermission) => {
    if (ur.includes('campaigns') || ur.includes('ADVERTISER') || ur.includes('SUPPLY_MARKETPLACE') || ur.includes('FORECAST') || ur.includes('PMP') || ur.includes('TARGETING')) {
      return ur;
    }
  }),
  [UserRole.REV_OPS]: Object.values(RolePermission).filter((ur: RolePermission) => {
    if (ur.includes('FORECAST') || ur.includes('SUPPLY_MARKETPLACE') || ur.includes('KEYWORDS')) {
      return ur;
    }
  }),
  [UserRole.DESIGNER]: [RolePermission.CAMPAIGNS_CREATIVES_CREATE, RolePermission.CAMPAIGNS_CREATIVES_READ, RolePermission.CAMPAIGNS_CREATIVES_SETTINGS, RolePermission.CAMPAIGNS_CREATIVES_UPDATE, RolePermission.CAMPAIGNS_CREATIVES_PROCESS, RolePermission.TARGETING_READ, RolePermission.TARGETING_CREATE, RolePermission.TARGETING_EDIT],
  [UserRole.PUBLISHER]: [RolePermission.RB_SCHEDULE_CREATE]
};

@Injectable()
export class RolePermissionService {

  constructor(private principal: Principal) {
  }

  hasPermissions(permissions: RolePermission[]) {
    const roles = this.principal.getUser().roles;
    if (permissions && permissions.length) {
      if (roles) {
        return roles.some(role => {
          const permissionsForRole = RolesWithPermissions[role] as RolePermission[];
          return permissionsForRole && permissionsForRole.some(p => permissions.includes(p));
        });
      }
    }
    return false;
  }
}

